import styled from 'styled-components';
import MUIButton from '@material-ui/core/Button';
import MUIGrid from '@material-ui/core/Grid';

import { FormGridItem } from '@shared/components/Form';

export { default as CircularProgress } from '@material-ui/core/CircularProgress';

export const Container = styled(FormGridItem)`
  padding: 0.3rem 0;
`;

export const Button = styled(MUIButton).attrs({
  type: 'button' as 'button' | 'submit' | 'reset' | undefined,
  fullWidth: true as boolean,
  variant: 'outlined' as 'text' | 'outlined' | 'contained' | undefined,
  color: 'error' as
    | 'inherit'
    | 'error'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'info'
    | 'warning'
    | undefined,
})``;

export const ContainerChildren = styled(MUIGrid)``;
